import styled from "styled-components";

const Form = styled.form`
  margin: 0;
  padding: 0;
`;

export default Form;
